import { cn } from '@/lib/cn';

/**
 * Label/value grid for read-only detail views. Two columns on >= md screens,
 * single column on mobile. Renders an em dash for blank values.
 */
export function DetailList({
    items,
    className,
}: {
    items: { label: string; value: React.ReactNode }[];
    className?: string;
}) {
    return (
        <dl className={cn('grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-3', className)}>
            {items.map((item, i) => (
                <div key={i}>
                    <dt className="text-2xs font-bold uppercase tracking-wider text-text-subtle mb-0.5">
                        {item.label}
                    </dt>
                    <dd className="text-sm text-text">{blankAsDash(item.value)}</dd>
                </div>
            ))}
        </dl>
    );
}

function blankAsDash(v: React.ReactNode): React.ReactNode {
    if (v === null || v === undefined) return <span className="text-text-subtle">—</span>;
    if (typeof v === 'string' && v.trim() === '') return <span className="text-text-subtle">—</span>;
    return v;
}
